import { Stack } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import { type FC, useMemo } from 'react';
import dayjs from 'dayjs';
import { toDueString } from '../../helpers/datetime';
import { findQuestByName, getVoicePostponeDate } from '../../helpers/quest';
import { useCachedQuests } from '../../hooks/caching/quest';
import { PostponeQuestVoiceAction } from '../../types/voice';
import { CommonIcon } from '../common/CommonIcon';

interface ActionCardPostponeViewProps {
  action: PostponeQuestVoiceAction;
}

const hintStyle = { fontSize: 11, color: 'var(--tg-theme-hint-color)' };

export const ActionCardPostponeView: FC<ActionCardPostponeViewProps> = ({ action }) => {
  const quests = useCachedQuests();
  const dueStr = useMemo(() => {
    if (action.dueDateIso && dayjs(action.dueDateIso).isValid()) {
      return toDueString(dayjs(action.dueDateIso));
    }
    const quest = action.questId
      ? quests.find((q) => q.id === action.questId)
      : findQuestByName(quests, action.questName);
    return quest ? toDueString(getVoicePostponeDate(quest)) : 'Select date';
  }, [action, quests]);

  return (
    <Stack direction="row" alignItems="center" gap={0.5} flexShrink={0}>
      <CommonIcon type="filled" color="var(--tg-theme-hint-color)" icon="event" size={12} />
      <Text style={hintStyle}>{dueStr}</Text>
    </Stack>
  );
};
